exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-form .error-valid[data-v-b87c9056]{bottom:-47%;right:2%;left:auto}", ""]);

// exports
